<div class="mainDashboardPage">
    <div class="mainDashboard-layout">
        <!-- Sidebar Izquierdo -->
        <div class="mainDashboard-sidebar">
            <dashboard-sidebar 
                [selectedMonth]="selectedMonth" 
                [selectedDate]="selectedDate"
                (monthSelected)="onMonthSelected($event)">
            </dashboard-sidebar>
        </div>

        <!-- Área de Contenido Principal -->
        <div class="mainDashboard-content">
            <div class="header-flex">
                <div class="header-left">
                    <!-- <mat-icon class="header-back-icon">arrow_back</mat-icon> -->
                    <h1 class="header-title">Dashboard</h1>
                </div>

                <div class="header-tabs">
                    <div class="tab-item tab-actives">
                        <span class="tab-label">Activos</span>
                        <span class="tab-count">{{dashboardDataResponse.totalLocations_Actives}}</span>
                    </div>
                    <div class="tab-item">
                        <span class="tab-label">Inactivos</span>
                        <span class="tab-count">{{dashboardDataResponse.totalLocations_Inactives}}</span>
                    </div>
                </div>
            </div>
            
            <div class="main-flex">
                <div class="cards-flex">
                    <mat-card class="mainDashboard-card mainDashboard-card-wide">
                        <mat-card-content>
                            <locations-card [dashboardDataResponse]="dashboardDataResponse"></locations-card>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="table-flex">
                    <mat-card class="container-alarmsByDayByMonth">
                        <mat-card-content>
                            <alarm-chart [dashboardAlarms]="dashboardDataResponse.alarms" [currentMonth]="selectedMonthDisplay" [selectedDate]="selectedDate"></alarm-chart>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</div>